export default __webpack_public_path__ + "static/media/uploader-medtronic6xG-problem-1.1492f0de.png";